import SelectAsync from "../SelectAsync";
import { SelectOptionType } from "types/select/SelectOptionType";
import { SingleValue } from "react-select";
import { api } from "constants/RotasAPI";

interface SelectCondominiosProps {
  onChange: (opcaoSelecionada: SingleValue<SelectOptionType<any>>) => void;
  label: string;
  invalidateQuerysKey?: unknown[];
  isClearable?: boolean;
  placeholder?: string;
}

const SelectCondominios: React.FC<SelectCondominiosProps> = (props) => {
  return (
    <SelectAsync
      id="selecionar-condominio"
      nomeAtributoLabel="nomeFantasia"
      nomeAtributoValue="id"
      usarValidacaoParaFormulario={false}
      endpoint={api.condominio.getRegistrosCondominios}
      isClearable={props.isClearable}
      placeholder={props.placeholder}
      label={props.label}
      onChange={props.onChange}
    />
  );
};

export default SelectCondominios;
